import { SxProps, Theme } from '@mui/material/styles';

export const repurchaseTitleSX: SxProps<Theme> = {
	m: 0,
	fontSize: { xs: '17px', md: '20px' },
	fontWeight: 800,
	lineHeight: 1.3,
	letterSpacing: '0.01em',
	textTransform: 'uppercase',
	color: '#2c2c2c',
};

export const repurchaseLinkSX: SxProps<Theme> = {
	flexShrink: 0,
	fontSize: { xs: '16px', md: '18px' },
	fontWeight: { xs: 400, md: 500 },
	color: '#774A91',
	whiteSpace: 'nowrap',
	textDecoration: 'none',
	'&:hover, &:focus-visible': { textDecoration: 'underline' },
};

export const repurchaseCouponTextSX: SxProps<Theme> = {
	font: 'inherit',
	color: 'inherit',
};

export const repurchaseStrongSX: SxProps<Theme> = {
	font: 'inherit',
	fontWeight: 700,
	color: 'inherit',
};

export const repurchaseTermsSX: SxProps<Theme> = {
	m: { xs: '12px 0 0', md: '14px 0 0' },
	fontSize: { xs: '11.5px', md: '12px' },
	lineHeight: 1.45,
	color: '#6b6b6b',
};

export const repurchaseProductSizeSX: SxProps<Theme> = {
	mt: '2px',
	fontSize: { xs: '11px', md: '12px' },
	color: '#6b6b6b',
};

export const repurchaseProductCouponPriceSX: SxProps<Theme> = {
	color: '#B40309',
};

export const repurchaseUrgencySX: SxProps<Theme> = {
	fontWeight: 700,
};

export const repurchaseUrgencyInlineSX: SxProps<Theme> = {
	fontWeight: 700,
	display: { xs: 'none', md: 'inline' },
};

export const repurchaseUrgencyLineSX: SxProps<Theme> = {
	fontWeight: 700,
	display: { xs: 'block', md: 'none' },
};

export const repurchaseCouponHintSX: SxProps<Theme> = {
	fontFamily: 'inherit',
	fontSize: '12px',
	lineHeight: '15px',
	color: 'inherit',
	display: { xs: 'block', md: 'none' },
};
